import React, { useState } from 'react';
import MainContainer from '@components/mainContainer/MainContainer';
import MainHeader from '@components/mainHeader/MainHeader';
import NavSidebar from '@components/navSidebar/NavSidebar';
import { LayoutProps } from './Layout.types';
import { Container, StyledMain } from './LoggedLayout.styles';

const LoggedLayout = (props: LayoutProps) => {
  const { children } = props;
  const [activeMenu, setActiveMenu] = useState(false);

  const toggleMenu = () => {
    setActiveMenu(!activeMenu);
  };
  const closeMenu = () => {
    setActiveMenu(false);
  };

  return (
    <Container>
      <NavSidebar active={activeMenu} closeMenu={closeMenu} />
      <StyledMain>
        <MainHeader activeMenu={activeMenu} toggleMenu={toggleMenu} />
        <MainContainer>{children}</MainContainer>
      </StyledMain>
    </Container>
  );
};

export default LoggedLayout;
